import { h2, paragraph } from "@/styles/typography";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 55px;

  @media screen and (max-width: 992px) {
    margin-bottom: 18px;
  }
`;

const Title = styled(h2)`
  margin-bottom: 18px;

  @media screen and (max-width: 992px) {
    margin-bottom: 10px;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: -10px;
  align-items: center;
`;

const Text = styled(paragraph)`
  padding: 0 10px;
  margin-bottom: 5px;
  border-right: 2px solid ${({ theme }) => theme.colors.tango};
`;

const S = {
  Container,
  Title,
  TextWrapper,
  Text,
};

export default S;
